/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.24.0
 */

export const SELECT_LIST_VERTICAL_PADDING = 10; // in px
export const FIXED_SIZE_LIST_HEIGHT = 200; // in px
